import { combineReducers } from 'redux';

import global from './global';
import app from './app';

export default combineReducers({
  global,
  app,
});
